import { EventStateEnum } from '../../../generated/api.graphql';

/**
 * Mirrors the legacy `Events.Event.EventState`. The AppSchema enum exposes the
 * same uppercase wire names, so the admin's `?state=` URL contract and filter
 * defaults carry over unchanged.
 */
export const EventState = Object.freeze({
  HOLD: EventStateEnum.Hold,
  CONFIRMED: EventStateEnum.Confirmed,
  CANCELED: EventStateEnum.Canceled,
  DELETED: EventStateEnum.Deleted,
});

export type EventState = (typeof EventState)[keyof typeof EventState];
